<template>
  <div class="row m-0 mx-2 right-menu" v-show="this.$store.state.isShowRightMenu">

    <!-- <RightMenuCart v-if="isShowCartView" /> -->
    <!-- <RightMenuUpload v-if="isShowUploadView" /> -->
    <RightMenuEdit v-if="isShowEditView" />
    <RightMenuDraft v-if="isShowDraftView" />
    <RightMenuPreview v-if="isShowPreviewView" />
    <RightMenuSamplePreview v-if="isShowSamplePreviewView" />
    <RightMenuEventImageUpload v-if="isShowEventImageUploadView" />
    <RightMenuFirstTimeFreeUpload v-if="isShowFirstTimeFreeUploadView" />
  </div>
</template>

<script>
import { RightViewState } from "@/js/Const.js";
// import RightMenuCart from "@/components/acyrpro/RightMenuCart_Ap.vue";
import RightMenuEdit from "@/components/acyrpro/RightMenuEdit_Ap.vue";
// import RightMenuUpload from "@/components/acyrpro/RightMenuUpload_Ap.vue";
import RightMenuDraft from "@/components/acyrpro/RightMenuDraft_Ap.vue";
import RightMenuPreview from "@/components/acyrpro/RightMenuPreview_Ap.vue";
import RightMenuSamplePreview from "@/components/acyrpro/acryl-sample/RightMenuSamplePreview_Ap.vue";
import RightMenuEventImageUpload from "@/components/acyrpro/ticket/RightMenuEventImageUpload_Ap.vue";
import RightMenuFirstTimeFreeUpload from "@/components/acyrpro/first-time-free/RightMenuFirstTimeFreeUpload_Ap.vue";


export default {
  name: "RightMenu_Ap",
  props: {},
  data: function () {
    return {

    };
  },
  computed: {
    isShowCartView(){
      return this.$store.state.rightViewState == RightViewState.Cart;
    },
    // isShowUploadView(){
    //   return this.$store.state.rightViewState == RightViewState.Upload;
    // },
    isShowEditView(){
      return this.$store.state.rightViewState == RightViewState.Edit;
    },
    isShowDraftView(){
      return this.$store.state.rightViewState == RightViewState.Draft;
    },
    isShowPreviewView(){
      return this.$store.state.rightViewState == RightViewState.Preview;
    },
    isShowSamplePreviewView(){
      return this.$store.state.rightViewState == RightViewState.SamplePreview;
    },
    isShowEventImageUploadView(){
      return this.$store.state.rightViewState == RightViewState.EventImageUpload;
    },
    isShowFirstTimeFreeUploadView(){
      return this.$store.state.rightViewState == RightViewState.FirstTimeFreeUpload;
    },
  },
  created: function () {},
  components: {
    // RightMenuCart,
    RightMenuEdit,
    // RightMenuUpload,
    RightMenuDraft,
    RightMenuPreview,
    RightMenuSamplePreview,
    RightMenuEventImageUpload,
    RightMenuFirstTimeFreeUpload,
  },
  methods: {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.right-menu{
  background-color: $background-white-color;
  /* border-radius: 5px; */
  height: calc(100vh - #{$header-height});
}

</style>
